import React, { Component, Fragment, createRef } from "react";
import { I18n } from "react-redux-i18n";
import Modal from "@alboompro/boom-components/data-display/modal";
import Icon from "@alboompro/boom-components/general/icon";
import Button from "@alboompro/boom-components/general/button";
import EditorLabel from "editor/components/EditorLabel";

import {
  Wrapper,
  FooterContent,
  CustomPropListItem,
  CustomPropLabel,
  IconWrapper,
  SearchInput
} from "./styles";

import Icons from "./icons";

class IconSelector extends Component {
  constructor(props) {
    super(props);
    this.openRef = createRef();
    this.state = {
      loaded: false,
      visible: false,
      searchTerm: null,
      selected: props.icon || null
    };
  }

  componentDidMount() {
    this.loadCSS();
  }

  handleClose = e => {
    this.setState({ visible: false });
  };

  openModal = e => {
    e && e.preventDefault();
    this.setState({ visible: true });
  };

  filterFn = e => {
    const val =
      e.target.value !== undefined || e.target.value !== ""
        ? e.target.value
        : null;
    this.setState({ searchTerm: val });
  };

  loadCSS = () => {
    const el = document.getElementById("cp-editor-fa");
    if (el) {
      this.setState({ loaded: true });
      return;
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.id = "cp-editor-fa";
    link.href =
      "https://storage.alboompro.com/static/boom-v3/assets/vendors/font-awesome/5.9.0/css/all.min.css?v=2.8.493";
    link.onload = () => {
      this.setState({ loaded: true });
    };
    document.head.appendChild(link);
  };

  handleSelection = icon => {
    this.setState({ selected: icon });
  };

  confirmSelection = e => {
    e && e.preventDefault();
    const { updaterFn, name } = this.props;
    const { selected } = this.state;
    updaterFn({ prop: name, value: selected });
    this.setState({ visible: false });
  };

  render() {
    const { visible, searchTerm, loaded, selected } = this.state;
    if (!loaded) return null;

    const { tooltip, locale, label, currentValue } = this.props;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    return (
      <Fragment>
        <CustomPropListItem>
          <CustomPropLabel>
            <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
            <IconWrapper>
              <i className={currentValue} />
              <span className="switch" onClick={this.openModal}>
                <Icon
                  kind="regular"
                  group="interface-essential"
                  category="multimedia-controls"
                  file="button-refresh-arrows.svg"
                  size="12"
                  color="#fff"
                />
                {I18n.t("editPanel.iconPicker.changeIcon")}
              </span>
            </IconWrapper>
          </CustomPropLabel>
        </CustomPropListItem>
        <Modal
          visible={visible}
          title={I18n.t("editPanel.iconPicker.title")}
          onClose={this.handleClose}
          width={800}
          bodyStyle={{ display: "flex", flex: 1, overflow: "hidden;" }}
          footer={
            <FooterContent>
              <Button
                style={{
                  backgroundColor: "transparent",
                  border: "1px solid #bbbbbb"
                }}
                textStyle={{ color: "#525252" }}
                onClick={this.handleClose}
              >
                {I18n.t("general.cancel")}
              </Button>
              <Button
                type="primary"
                style={{ backgroundColor: "#50AFF4" }}
                onClick={this.confirmSelection}
              >
                {I18n.t("general.choose")}
              </Button>
            </FooterContent>
          }
        >
          <Wrapper>
            <div className="search-container">
              <SearchInput
                placeholder={I18n.t("general.search")}
                onChange={this.filterFn}
                prefix={
                  <Icon
                    kind="bold"
                    group="interface-essential"
                    category="search"
                    file="search-1.svg"
                    size="16"
                    color="#C2C2C2"
                  />
                }
              />
            </div>
            <div className="results-listing">
              <Icons
                selected={selected}
                searchTerm={searchTerm}
                handleClick={this.handleSelection}
              />
            </div>
          </Wrapper>
        </Modal>
      </Fragment>
    );
  }
}

export default IconSelector;
